import React from "react";
import styled from "styled-components";

import { Button } from "./Button";

export const BlackButton = styled((props) => <Button {...props} />).attrs(
  (props) => ({
    automationid:
      props.automationid ||
      `SalesLead_button_${props?.automationidattr?.replace(/ /g, "")}_1"`,
  })
)`
  border: 1px solid #ffffff;
  color: white;
  background: #282828;
  &:hover {
    background: #313131;
  }

  &:disabled {
    background: #ebebeb;
    color: #cccccc;
    border: none;
  }
`;
